import React, {Component} from 'react';

import SearchProvider from '../../search-filter/components/search-container';
import SearchResults from '../../search-filter/components/search-results';
import { fetchRelatedPages } from '../related-pages-actions';

class RelatedPages extends Component {

  constructor(props) {
    super(props);
  }

  getRelatedPages = () => {
    const { pageInfo, filter, _source } = this.props
    return fetchRelatedPages(pageInfo, filter, _source);
  }

  render() {

    const { header=null, keyword='relatedPages', resultMapper, searchFunc} = this.props;

    return (
      <SearchProvider
          searchFunc={searchFunc || this.getRelatedPages}
          searchKey={keyword}
          resultMapper={resultMapper}
      >
          <SearchResults>
              {
                ({ results }) => this.props.children({ relatedPages: results })
              }
          </SearchResults>
      </SearchProvider>
    );
  }
}

export default RelatedPages;
